import React from "react";
import { ArrowLeftCircle } from 'react-feather';

import './index.scss'

const CancelButton = ({
  onClick,
  title
}) => {


  return (
    <>
      {
        <div className="Cancel-button__Cancel" onClick={onClick}><ArrowLeftCircle/>{title}</div>
      }
    </>
  )
}

export default CancelButton
